import React, { useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { PlusCircle } from 'lucide-react';
import AddItemModal from './AddItemModal';

const ItemDropdownWithAddButton = ({
  value,
  onChange,
  itemData,
  disabled,
  error,
  label = 'Item Name',
  required = false,
  style = {},
}) => {
  const [showAddItemModal, setShowAddItemModal] = useState(false);

  const handleItemCreated = (newItem) => {
    onChange(newItem._id);
    setShowAddItemModal(false);
  };

  return (
    <>
      <div className="input-block local-forms custom-dropdown">
        <label>
          {label} {required && <span className="login-danger">*</span>}
        </label>
        <div className="d-flex gap-2">
          <div className="flex-grow-1">
            <Dropdown
              placeholder="Select Item"
              filter
              value={value}
              options={itemData.map(e => ({ label: e?.name, value: e?._id }))}
              onChange={(e) => onChange(e.value)}
              filterBy="label"
              disabled={disabled}
              className={`w-100 ${error ? 'p-invalid' : ''}`}
              enforceFocus={false}
              showClear={!!value}
              appendTo="self"
              style={disabled ? { backgroundColor: '#e9ecef', color: 'black' } : {}}
            />
          </div>
          <button
            type="button"
            className="btn btn-sm btn-outline-primary mt-1 d-flex align-items-center justify-content-center"
            style={{ width: '40px', height: '38px' }}
            data-bs-toggle="tooltip"
            data-bs-title="Add New Item"
            onClick={() => setShowAddItemModal(true)}
          >
            <PlusCircle size={16} />
          </button>
        </div>
        {error && <small className="p-error">{error}</small>}
      </div>

      <AddItemModal
        isOpen={showAddItemModal}
        onClose={() => setShowAddItemModal(false)}
        onItemCreated={handleItemCreated}
      />
    </>
  );
};

export default ItemDropdownWithAddButton;
